import { useQuestionnaireContext } from "../context/QuestionnaireContext";
import { QuestionnaireAlert } from "./shared/QuestionnaireAlert";
import { QuestionnaireLoader } from "./shared/QuestionnaireLoader";
import { QuestionnaireStep } from "./steps/QuestionnaireStep";
import { QuestionnaireSummaryStep } from "./steps/QuestionnaireSummaryStep";
import { QuestionnaireFinalStep } from "./steps/QuestionnaireFinalStep";

export function QuestionnaireContent() {
  const { currentStep, loadingState, shouldShowAlert, questionnaireQuery } =
    useQuestionnaireContext();

  if (loadingState?.isLoading) {
    return <QuestionnaireLoader reason={loadingState.reason} />;
  }

  if (!questionnaireQuery.data || shouldShowAlert) {
    return <QuestionnaireAlert />;
  }

  switch (currentStep) {
    case "form":
      return <QuestionnaireStep />;

    case "summary":
      return <QuestionnaireSummaryStep />;

    case "final":
      return <QuestionnaireFinalStep />;

    default:
      return null;
  }
}
